import { ensureNumber } from "@welshman/lib";
import { getTagValues } from "@welshman/util";
import { FeedType, } from "./core.js";
export const makeAddressFeed = (...addresses) => [
    FeedType.Address,
    ...addresses,
];
export const makeAuthorFeed = (...pubkeys) => [FeedType.Author, ...pubkeys];
export const makeCreatedAtFeed = (...items) => [
    FeedType.CreatedAt,
    ...items,
];
export const makeDVMFeed = (...items) => [FeedType.DVM, ...items];
export const makeDifferenceFeed = (...feeds) => [
    FeedType.Difference,
    ...feeds,
];
export const makeIDFeed = (...ids) => [FeedType.ID, ...ids];
export const makeIntersectionFeed = (...feeds) => [
    FeedType.Intersection,
    ...feeds,
];
export const makeGlobalFeed = () => [FeedType.Global];
export const makeKindFeed = (...kinds) => [FeedType.Kind, ...kinds];
export const makeListFeed = (...items) => [FeedType.List, ...items];
export const makeLabelFeed = (...items) => [FeedType.Label, ...items];
export const makeWOTFeed = (...items) => [FeedType.WOT, ...items];
export const makeRelayFeed = (...urls) => [FeedType.Relay, ...urls];
export const makeScopeFeed = (...scopes) => [FeedType.Scope, ...scopes];
export const makeSearchFeed = (...searches) => [FeedType.Search, ...searches];
export const makeTagFeed = (key, ...values) => [
    FeedType.Tag,
    key,
    ...values,
];
export const makeUnionFeed = (...feeds) => [FeedType.Union, ...feeds];
export const isAddressFeed = (feed) => feed[0] === FeedType.Address;
export const isAuthorFeed = (feed) => feed[0] === FeedType.Author;
export const isCreatedAtFeed = (feed) => feed[0] === FeedType.CreatedAt;
export const isDVMFeed = (feed) => feed[0] === FeedType.DVM;
export const isDifferenceFeed = (feed) => feed[0] === FeedType.Difference;
export const isIDFeed = (feed) => feed[0] === FeedType.ID;
export const isIntersectionFeed = (feed) => feed[0] === FeedType.Intersection;
export const isGlobalFeed = (feed) => feed[0] === FeedType.Global;
export const isKindFeed = (feed) => feed[0] === FeedType.Kind;
export const isListFeed = (feed) => feed[0] === FeedType.List;
export const isLabelFeed = (feed) => feed[0] === FeedType.Label;
export const isWOTFeed = (feed) => feed[0] === FeedType.WOT;
export const isRelayFeed = (feed) => feed[0] === FeedType.Relay;
export const isScopeFeed = (feed) => feed[0] === FeedType.Scope;
export const isSearchFeed = (feed) => feed[0] === FeedType.Search;
export const isTagFeed = (feed) => feed[0] === FeedType.Tag;
export const isUnionFeed = (feed) => feed[0] === FeedType.Union;
export function getFeedArgs(feed) {
    switch (feed[0]) {
        case FeedType.Intersection:
            return feed.slice(1);
        case FeedType.Union:
            return feed.slice(1);
        case FeedType.Difference:
            return feed.slice(1);
        case FeedType.Address:
            return feed.slice(1);
        case FeedType.Author:
            return feed.slice(1);
        case FeedType.ID:
            return feed.slice(1);
        case FeedType.Relay:
            return feed.slice(1);
        case FeedType.Search:
            return feed.slice(1);
        case FeedType.Tag:
            return feed.slice(1);
        case FeedType.CreatedAt:
            return feed.slice(1);
        case FeedType.List:
            return feed.slice(1);
        case FeedType.Label:
            return feed.slice(1);
        case FeedType.DVM:
            return feed.slice(1);
        case FeedType.WOT:
            return feed.slice(1);
        case FeedType.Scope:
            return feed.slice(1);
        case FeedType.Kind:
            return feed.slice(1);
        case FeedType.Global:
            return feed.slice(1);
        default:
            throw new Error(`Invalid feed type ${feed[0]}`);
    }
}
export const hasSubFeeds = (feed) => [FeedType.Union, FeedType.Intersection, FeedType.Difference].includes(feed[0]);
export const defaultTagFeedMappings = [
    ["a", [FeedType.Address]],
    ["e", [FeedType.ID]],
    ["p", [FeedType.Author]],
    ["r", [FeedType.Relay]],
    ["t", [FeedType.Tag, "#t"]],
];
export const feedsFromTags = (tags, mappings) => {
    const feeds = [];
    for (const [tagName, templateFeed] of mappings || defaultTagFeedMappings) {
        let values = getTagValues(tagName, tags);
        if (values.length > 0) {
            if (isKindFeed(templateFeed)) {
                values = values.map(ensureNumber);
            }
            feeds.push([...templateFeed, ...values]);
        }
    }
    return feeds;
};
export const feedFromTags = (tags, mappings) => makeIntersectionFeed(...feedsFromTags(tags, mappings));
export const feedsFromFilter = ({ since, until, ...filter }) => {
    const feeds = [];
    if (since && until) {
        feeds.push(makeCreatedAtFeed({ since, until }));
    }
    else if (since) {
        feeds.push(makeCreatedAtFeed({ since }));
    }
    else if (until) {
        feeds.push(makeCreatedAtFeed({ until }));
    }
    for (const [k, v] of Object.entries(filter)) {
        if (k === "ids")
            feeds.push(makeIDFeed(...v));
        else if (k === "kinds")
            feeds.push(makeKindFeed(...v));
        else if (k === "authors")
            feeds.push(makeAuthorFeed(...v));
        else if (k.startsWith("#"))
            feeds.push(makeTagFeed(k, ...v));
        else
            throw new Error(`Unable to create feed from filter ${k}: ${v}`);
    }
    return feeds;
};
export const feedFromFilter = (filter) => makeIntersectionFeed(...feedsFromFilter(filter));
export const feedFromFilters = (filters) => makeUnionFeed(...filters.map(filter => feedFromFilter(filter)));
export const walkFeed = (feed, visit) => {
    visit(feed);
    if (hasSubFeeds(feed)) {
        for (const subFeed of getFeedArgs(feed)) {
            walkFeed(subFeed, visit);
        }
    }
};
//# sourceMappingURL=utils.js.map